export default "__VITE_ASSET__4066c8f7__"